module.exports = __webpack_public_path__ + "static/media/Cedar.85a7ffd5.png";